import { useTranslation } from 'react-i18next'
import { InAppTemplateData } from '../../../../types'
import { Heading, InfoTable, Tag } from '../../../../ui'
import VariableDisplay from '../../../../ui/form/VariableDisplay'
import { useExpiresAtLabel } from './ExpiresAtField'
import { NoDismissAlert } from './NoDismissAlert'

export const InAppTable = ({ data }: { data: InAppTemplateData }) => {
    const { t } = useTranslation()
    const expiresAtLabel = useExpiresAtLabel()

    const isPopup = data.editor === 'popup'

    return <>
        <NoDismissAlert data={data} />
        <InfoTable rows={{
            [t('title')]: data.title
                ? <VariableDisplay value={data.title} />
                : <Tag variant="warn">{t('missing')}</Tag>,
            [t('body')]: data.body
                ? <VariableDisplay value={data.body} />
                : <Tag variant="warn">{t('missing')}</Tag>,
            ...(isPopup
                ? { [t('editor')]: 'Popup Builder' }
                : {}),
        }} />
        {!isPopup && <>
            <Heading title={t('fields')} size="h4" />
            {data.fields?.length
                ? <InfoTable rows={{
                    ...(data.fields.reduce((acc: Record<string, any>, curr: any) => {
                        const value = data.custom?.[curr.key]
                        acc[curr.name] = curr.type === 'image' && value
                            ? <img src={value as string} alt={curr.name} className="info-table-thumbnail" />
                            : value
                        return acc
                    }, {}) ?? {}),
                }} />
                : <InfoTable rows={{
                    [t('raw_json')]: JSON.stringify(data.custom),
                }} />
            }
        </>}
        <Heading title={t('advanced')} size="h4" />
        <InfoTable rows={{
            [t('read_on_view')]: data.read_on_show,
            [t('expires_at')]: expiresAtLabel(data.expires_at, data.expires_in_user_timezone) ?? data.expires_at,
        }} />
    </>
}
